import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {NumberInfo} from "#template/interface-descriptors"
import {numberMarker} from "#template/nodes/number/marker"
export {numberLikeMarker, isNumberLikeNode, isNumberLikeNodeClass, isNumberLike, numberLikeNode, numberLike} from "#template/nodes/number/marker"
export type {NumberLikeNode, NumberLike} from "#template/nodes/number/marker"
export const NumberFT = createFundamentalType({
    name: "Number",
    marker: numberMarker,
    InfoClass: NumberInfo,
    icon: "far fa-input-numeric",
})

@registerFundamentalNode(NumberFT, "Likes")
export class NumberLikes extends NumberFT.Likes {}

@registerFundamentalNode(NumberFT, "Switch")
export class NumberSwitch extends NumberFT.Switch {}

@registerFundamentalNode(NumberFT, "Input")
export class NumberInput extends NumberFT.Input {}

@registerFundamentalNode(NumberFT, "Output")
export class NumberOutput extends NumberFT.Output {}

@registerFundamentalNode(NumberFT, "Export")
export class NumberExport extends NumberFT.Export {}
